<template>
  <div class="careregistrationDetial" v-if="detialInfo">
    <el-row>
      <el-col class="leftTitle" :span="4">任务名称:</el-col>
      <el-col class="" :span="20">{{ detialInfo.dutyName }}</el-col>
    </el-row>
    <el-row>
      <el-col class="leftTitle" :span="4">上报人:</el-col>
      <el-col class="" :span="20">{{ detialInfo.reporter }}</el-col>
    </el-row>
    <el-row>
      <el-col class="leftTitle" :span="4">处理时间:</el-col>
      <el-col class="" :span="20">{{ detialInfo.handleTime }}</el-col>
    </el-row>
    <template v-if="detialInfo.state !== '4'">
      <el-row>
        <el-col class="leftTitle" :span="4">处理人:</el-col>
        <el-col class="" :span="20">{{ detialInfo.handler }}</el-col>
      </el-row>

      <el-row>
        <el-col class="leftTitle" :span="4">上报时间:</el-col>
        <el-col class="" :span="20">{{ detialInfo.reportTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="leftTitle" :span="4">处理内容:</el-col>
        <el-col class="" :span="20">{{ detialInfo.handleContent }}</el-col>
      </el-row>
      <el-row>
        <el-col class="leftTitle" :span="4">处理记录:</el-col>
        <el-col class="" :span="20">{{ detialInfo.handleRecord }}</el-col>
      </el-row>
    </template>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  nextTick,
} from "vue";
import { Plus } from "@element-plus/icons-vue";
import { dutyDetailInfo } from "@/api/communityCare/communityCareApi.js";
import { formatDateYMD } from "@/utils/library/js/util.js";
import { ElMessage } from "element-plus";
import { queryUserList } from "@/api/user.js";
// import _ from "lodash";
export default defineComponent({
  components: { Plus },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const formRef = ref(null);
    const state = reactive({
      detialInfo: {},
    });
    watchEffect(() => {
      if (props.form) {
        nextTick(() => {
          getDetialInfo(props.form.dutyDetailId);
        });
      }
    });
    const getDetialInfo = async (id) => {
      const res = await dutyDetailInfo({ id: id });
      state.detialInfo = res.data;
      console.log(state.detialInfo);
    };

    return {
      ...toRefs(state),
    };
  },
});
</script>
<style lang="scss" scoped>
.careregistrationDetial {
  .el-row {
    height: 50px;
    font-size: 14px;
    .leftTitle {
      font-size: 16px;
      font-weight: 800;
    }
  }
}
</style>
